export default __webpack_public_path__ + "static/media/kaishi.b8a48b7c.png";